import styled from 'styled-components';

export const Main = styled.div<{ padding?: string }>`
  overflow-y: scroll;
  padding: ${(props) => props.padding ?? 'var(--size-6)'};

  @media (min-width: 768px) {
    max-height: var(--size-96);
  }
`;
